(function () {
  "use strict";
  var SCHEMA_VERSION = "3",
    VISITOR_KEY = "lbg_mta_visitor_id",
    JOURNEY_KEY = "lbg_mta_journey_id",
    FIRST_TOUCH_KEY = "lbg_mta_first_touch",
    LAST_TOUCH_KEY = "lbg_mta_last_touch",
    SESSION_KEY = "lbg_mta_session_id",
    SESSION_STARTED_KEY = "lbg_mta_session_started",
    PRODUCT_VIEW_COUNT_KEY = "lbg_mta_product_view_count",
    MAX_PRODUCT_VIEWS_PER_SESSION = 5,
    SESSION_TTL_MS = 18e5;
  function uuid() {
    return window.crypto && typeof window.crypto.randomUUID == "function"
      ? window.crypto.randomUUID()
      : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
          var r = (Math.random() * 16) | 0;
          return (c === "x" ? r : (r & 3) | 8).toString(16);
        });
  }
  function read(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  function write(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (e) {}
  }
  function readJSON(storage, key) {
    try {
      return JSON.parse(read(storage, key) || "null");
    } catch (e) {
      return null;
    }
  }
  var now = Date.now(),
    visitorId = read(localStorage, VISITOR_KEY) || uuid(),
    journeyId = read(localStorage, JOURNEY_KEY) || uuid();
  (write(localStorage, VISITOR_KEY, visitorId),
    write(localStorage, JOURNEY_KEY, journeyId));
  var sessionStarted = Number(read(sessionStorage, SESSION_STARTED_KEY) || 0),
    sessionId = read(sessionStorage, SESSION_KEY);
  ((!sessionId || !sessionStarted || now - sessionStarted > SESSION_TTL_MS) &&
    ((sessionId = uuid()), (sessionStarted = now)),
    write(sessionStorage, SESSION_KEY, sessionId),
    write(sessionStorage, SESSION_STARTED_KEY, String(now)));
  var params = new URLSearchParams(window.location.search || ""),
    keys = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "gclid",
      "gbraid",
      "wbraid",
      "fbclid",
      "msclkid",
      "campaign_id",
      "ad_campaign_id",
      "gad_campaignid",
      "adset_id",
      "adgroup_id",
      "ad_id",
    ],
    observed = {};
  (keys.forEach(function (key) {
    var value = params.get(key);
    value && (observed[key] = value);
  }),
    (observed.landing_url = window.location.href),
    (observed.referrer_url = document.referrer || ""),
    (observed.timestamp_utc = new Date().toISOString()));
  var firstTouch = readJSON(localStorage, FIRST_TOUCH_KEY);
  firstTouch ||
    ((firstTouch = observed),
    write(localStorage, FIRST_TOUCH_KEY, JSON.stringify(firstTouch)));
  var hasNewAttribution = keys.some(function (key) {
      return !!observed[key];
    }),
    lastTouch = readJSON(localStorage, LAST_TOUCH_KEY) || firstTouch;
  (hasNewAttribution || !lastTouch) &&
    ((lastTouch = observed),
    write(localStorage, LAST_TOUCH_KEY, JSON.stringify(lastTouch)));
  function sourceFrom(touch) {
    if (touch.utm_source) return touch.utm_source;
    if (touch.gclid || touch.gbraid || touch.wbraid) return "google";
    if (touch.fbclid) return "meta";
    if (touch.msclkid) return "microsoft";
    try {
      var host = new URL(touch.referrer_url || "").hostname.toLowerCase();
      return /google\./.test(host)
        ? "google"
        : /facebook\.com|instagram\.com|fb\.com/.test(host)
          ? "meta"
          : /bing\.com/.test(host)
            ? "microsoft"
            : host || "direct";
    } catch (e) {
      return "direct";
    }
  }
  function channelFrom(touch) {
    var medium = (touch.utm_medium || "").toLowerCase();
    return /cpc|ppc|paid/.test(medium) ||
      touch.gclid ||
      touch.gbraid ||
      touch.wbraid ||
      touch.fbclid ||
      touch.msclkid
      ? "paid"
      : /email/.test(medium)
        ? "email"
        : /organic/.test(medium)
          ? "organic"
          : touch.referrer_url
            ? "referral"
            : "direct";
  }
  function consentState() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (p && typeof p.currentVisitorConsent == "function")
        return JSON.stringify(p.currentVisitorConsent());
    } catch (e) {}
    return "unknown";
  }
  function productContext() {
    var pathMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/),
      title = "",
      heading = document.querySelector("h1");
    return (
      heading && (title = (heading.textContent || "").trim()),
      { handle: pathMatch ? pathMatch[1] : "", title: title }
    );
  }
  function send(eventType, extras) {
    extras = extras || {};
    var touch = lastTouch || observed,
      product = productContext(),
      touchId = extras.touch_id || uuid(),
      payload = {
        touch_id: touchId,
        idempotency_key: extras.idempotency_key || touchId,
        event_timestamp_utc: new Date().toISOString(),
        event_type: eventType,
        visitor_id: visitorId,
        session_id: sessionId,
        journey_id: journeyId,
        source: sourceFrom(touch),
        platform: sourceFrom(touch),
        channel: channelFrom(touch),
        medium: touch.utm_medium || "",
        campaign_name: touch.utm_campaign || "",
        campaign_id:
          touch.campaign_id ||
          touch.ad_campaign_id ||
          touch.gad_campaignid ||
          "",
        adset_adgroup_id: touch.adset_id || touch.adgroup_id || "",
        ad_id: touch.ad_id || "",
        utm_source: touch.utm_source || "",
        utm_medium: touch.utm_medium || "",
        utm_campaign: touch.utm_campaign || "",
        utm_content: touch.utm_content || "",
        utm_term: touch.utm_term || "",
        gclid: touch.gclid || "",
        gbraid: touch.gbraid || "",
        wbraid: touch.wbraid || "",
        fbclid: touch.fbclid || "",
        fbc: read(localStorage, "_fbc") || "",
        fbp: read(localStorage, "_fbp") || "",
        msclkid: touch.msclkid || "",
        landing_url: window.location.href,
        referrer_url: document.referrer || "",
        page_path: window.location.pathname + window.location.search,
        product_handle: product.handle,
        product_title: product.title,
        interaction_type: extras.interaction_type || eventType,
        phone_number_displayed: extras.phone_number_displayed || "",
        form_event_id: extras.form_event_id || "",
        call_event_id: "",
        salesoptima_contact_id: "",
        match_method: "",
        match_confidence: "",
        observed_or_inferred: "observed",
        consent_state: consentState(),
        raw_evidence_json: JSON.stringify({
          first_touch: firstTouch,
          last_touch: lastTouch,
        }),
        ingested_at_utc: new Date().toISOString(),
        schema_version: SCHEMA_VERSION,
      };
    // Conversion-triggered mode: anonymous journey events stay in-browser/GA4.
    // They are not sent to Zapier individually. The compact journey is attached
    // to the site's existing lead-form request below, avoiding an extra webhook.
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "lbg_mta_" + eventType,
        lbg_mta: payload,
      });
    } catch (e) {}
    return payload;
  }
  function addHidden(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    (input ||
      ((input = document.createElement("input")),
      (input.type = "hidden"),
      (input.name = name),
      form.appendChild(input)),
      (input.value = value));
  }
  function sendOncePerSession(key, eventType, extras) {
    var storageKey = "lbg_mta_sent_" + key;
    if (read(sessionStorage, storageKey)) return !1;
    write(sessionStorage, storageKey, "1");
    send(eventType, extras || {});
    return !0;
  }
  function sendPrioritizedLandingAndProductTouch() {
    var currentChannel = channelFrom(observed),
      product = productContext();
    if (hasNewAttribution && currentChannel === "paid")
      sendOncePerSession("paid_landing", "paid_landing", {
        interaction_type: "paid_landing",
        idempotency_key: sessionId + ":paid_landing",
      });
    if (product.handle) {
      var productKey = "product_view_" + product.handle,
        count = Number(read(sessionStorage, PRODUCT_VIEW_COUNT_KEY) || 0);
      if (
        !read(sessionStorage, "lbg_mta_sent_" + productKey) &&
        count < MAX_PRODUCT_VIEWS_PER_SESSION
      ) {
        write(sessionStorage, PRODUCT_VIEW_COUNT_KEY, String(count + 1));
        sendOncePerSession(productKey, "product_view", {
          interaction_type: "product_view",
          idempotency_key: sessionId + ":product_view:" + product.handle,
        });
      }
    }
  }
  (sendPrioritizedLandingAndProductTouch(),
    document.addEventListener(
      "click",
      function (event) {
        var target =
          event.target && event.target.closest
            ? event.target.closest(
                'a[href^="tel:"], #callToggleBtn, [data-phone], [data-call]',
              )
            : null;
        if (target) {
          var href = target.getAttribute("href") || "",
            phone =
              href.indexOf("tel:") === 0
                ? href.slice(4)
                : (target.textContent || "").trim();
          sendOncePerSession(
            "phone_cta_" + window.location.pathname + "_" + phone,
            "phone_cta_click",
            {
              interaction_type: "phone_cta_click",
              phone_number_displayed: phone,
              idempotency_key:
                sessionId +
                ":phone_cta_click:" +
                window.location.pathname +
                ":" +
                phone,
            },
          );
        }
      },
      !0,
    ));
  function isLeadForm(form) {
    if (!form || form.nodeName !== "FORM") return !1;
    var action = (form.getAttribute("action") || "").toLowerCase();
    if (
      action.indexOf("/search") >= 0 ||
      action.indexOf("/cart") >= 0 ||
      action.indexOf("/account") >= 0 ||
      action.indexOf("/contact") >= 0
    )
      return !1;
    var names = [
        "firstname",
        "lastname",
        "email",
        "number",
        "phone",
        "city",
        "state",
        "zip",
      ],
      hits = names.reduce(function (total, name) {
        return total + (form.querySelector('[name="' + name + '" i]') ? 1 : 0);
      }, 0);
    return (
      hits >= 4 &&
      !!(
        form.querySelector('[name="txtLeadCommentsAppend"]') ||
        form.querySelector('[name="txtLeadMultiComments1"]')
      )
    );
  }
  function leadFormKey(form) {
    return (
      (form.getAttribute("id") || form.getAttribute("name") || "lead") +
      ":" +
      (form.getAttribute("action") || window.location.pathname)
    ).replace(/[^a-z0-9_:-]+/gi, "_");
  }
  document.addEventListener(
    "focusin",
    function (event) {
      var form = event.target && event.target.form;
      if (isLeadForm(form))
        sendOncePerSession(
          "form_engagement_" + leadFormKey(form),
          "form_engagement",
          {
            interaction_type: "form_engagement",
            idempotency_key:
              sessionId + ":form_engagement:" + leadFormKey(form),
          },
        );
    },
    !0,
  );
  (document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (isLeadForm(form)) {
        var existingFormEvent = form.querySelector(
            '[name="lbg_mta_form_event_id"]',
          ),
          formEventId =
            (existingFormEvent && existingFormEvent.value) || uuid();
        var journeyPayload = send("form_submit", {
          interaction_type: "form_submit",
          form_event_id: formEventId,
          idempotency_key: formEventId,
        });
        (addHidden(form, "lbg_mta_visitor_id", visitorId),
          addHidden(form, "lbg_mta_session_id", sessionId),
          addHidden(form, "lbg_mta_journey_id", journeyId),
          addHidden(form, "lbg_mta_form_event_id", formEventId),
          addHidden(
            form,
            "lbg_mta_journey_json",
            JSON.stringify(journeyPayload),
          ));
        var nl = "\n",
          bridgeText =
            "MTA Journey ID: " +
            journeyId +
            nl +
            "MTA Form Event ID: " +
            formEventId;
        (["txtLeadCommentsAppend", "txtLeadMultiComments1"].forEach(
          function (name) {
            var field = form.querySelector('[name="' + name + '"]');
            field &&
              (field.value =
                (field.value ? field.value + nl : "") + bridgeText);
          },
        ));
      }
    },
    !1,
  ),
    (window.LBGMultiTouchShadow = {
      version: SCHEMA_VERSION,
      visitorId: visitorId,
      sessionId: sessionId,
      journeyId: journeyId,
      firstTouch: firstTouch,
      lastTouch: lastTouch,
      send: send,
    }));
})();

//# sourceMappingURL=/cdn/shop/t/19/assets/lbg-mta-shadow.js.map?v=76189355090278100331786578403
